// import { useState } from "react";
// import BASE_URL from "../../config/config";
// export default function PayUCheckout() {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     amount: "",
//     firstName: "",
//     lastname: "",
//     email: "",
//     phone: "",
//     productInfo: "",
//     companyName: "",
//   });
//   const [errors, setErrors] = useState({});

//   // Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Validate form
//   const validateForm = () => {
//     let newErrors = {};
//     if (!formData.amount) newErrors.amount = "Amount is required";
//     if (!formData.firstName) newErrors.firstName = "First name is required";
//     if (!formData.email) newErrors.email = "Email is required";
//     if (!formData.phone) newErrors.phone = "Phone is required";
//     if (!formData.productInfo)
//       newErrors.productInfo = "Product info is required";
//     return newErrors;
//   };

//   // Handle submit
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//     } else {
//       setErrors({});
//       startPayment();
//     }
//   };

//   // Start PayU payment
//   const startPayment = async () => {
//     setLoading(true);
//     const body = {
//       amount: formData.amount,
//       productInfo: formData.productInfo,
//       firstname: formData.firstName,
//       email: formData.email,
//       phone: formData.phone,
//       udf1: formData.companyName,
//     };

//     const res = await fetch(`${BASE_URL}/payments/initiate`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(body),
//     });
//     const data = await res.json();
//     autoSubmitToPayU(data.paymentUrl, data.payURequest);
//     setLoading(false);
//   };

//   // Auto submit to PayU
//   const autoSubmitToPayU = (actionUrl, p) => {
//     const form = document.createElement("form");
//     form.method = "POST";
//     form.action = actionUrl;

//     const append = (name, value) => {
//       const input = document.createElement("input");
//       input.type = "hidden";
//       input.name = name;
//       input.value = value ?? "";
//       form.appendChild(input);
//     };

//     // Mandatory fields
//     append("key", p.key);
//     append("txnid", p.txnid);
//     append("amount", p.amount);
//     append("productinfo", p.productinfo);
//     append("firstname", p.firstname);
//     append("email", p.email);
//     append("phone", p.phone);
//     append("surl", p.surl);
//     append("furl", p.furl);
//     append("hash", p.hash);

//     // UDFs
//     append("udf1", p.udf1);

//     document.body.appendChild(form);
//     form.submit();
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
//       <div className="w-full max-w-4xl border-2 border-dashed border-main p-10 bg-[url('https://www.transparenttextures.com/patterns/gplay.png')] bg-repeat rounded-md">
//         <h2 className="md:text-3xl text-2xl text-main font-semibold text-center mb-8">
//           Transaction Details
//         </h2>

//         <form className="space-y-5" onSubmit={handleSubmit}>
//           {[
//             { label: "Amount", name: "amount", type: "number" },
//             { label: "First Name", name: "firstName", type: "text" },
//             { label: "Last Name", name: "lastname", type: "text" },
//             { label: "Email", name: "email", type: "email" },
//             { label: "Telephone", name: "phone", type: "tel" },
//             { label: "Product Info", name: "productInfo", type: "text" },
//             { label: "Company Name", name: "companyName", type: "text" },
//           ].map((field) => (
//             <div
//               key={field.name}
//               className="flex flex-col md:flex-row items-start md:items-center gap-2"
//             >
//               <label className="md:w-40 text-red-600 font-medium">
//                 * {field.label}:
//               </label>
//               <div className="w-full">
//                 <input
//                   type={field.type}
//                   name={field.name}
//                   value={formData[field.name]}
//                   onChange={handleChange}
//                   className="w-full p-2 border rounded"
//                 />
//                 {errors[field.name] && (
//                   <p className="text-red-500 text-sm">{errors[field.name]}</p>
//                 )}
//               </div>
//             </div>
//           ))}

//           <div className="flex justify-center md:justify-end">
//             <button
//               type="submit"
//               disabled={loading}
//               className="bg-sky-500 hover:bg-sky-600 text-white px-6 py-2 rounded font-semibold md:font-bold"
//             >
//               {loading ? "Starting..." : "Pay with PayU"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// this code running perfectlly 5/7/26

// import { useState } from "react";
// import BASE_URL from "../../config/config";

// export default function PayUCheckout() {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     amount: "",
//     firstName: "",
//     email: "",
//     phone: "",
//     productInfo: "",
//     companyName: "",
//   });
//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     if (!formData.amount) newErrors.amount = "Amount is required";
//     if (!formData.firstName) newErrors.firstName = "First name is required";

//     if (!formData.email) newErrors.email = "Email is required";
//     if (!formData.phone) newErrors.phone = "Phone is required";
//     if (!formData.productInfo)
//       newErrors.productInfo = "Product info is required";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setErrors({});
//     await startPayment();
//   };

//   const startPayment = async () => {
//     try {
//       setLoading(true);
//       const body = {
//         amount: formData.amount,
//         productInfo: formData.productInfo,
//         firstname: formData.firstName,

//         email: formData.email,
//         phone: formData.phone,
//         udf1: formData.companyName,
//       };
//       console.log("Initiating payment with body:", body);
//       const res = await fetch(`${BASE_URL}/payments/initiate`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(body),
//       });

//       const data = await res.json();
//       if (!data?.paymentUrl || !data?.payURequest) {
//         alert("Payment initialization failed.");
//         return;
//       }

//       // Redirect to PayU
//       autoSubmitToPayU(data.paymentUrl, data.payURequest);
//     } catch (error) {
//       console.error("Error starting payment:", error);
//       alert("Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const autoSubmitToPayU = (actionUrl, p) => {
//     const form = document.createElement("form");
//     form.method = "POST";
//     form.action = actionUrl;

//     const append = (name, value) => {
//       const input = document.createElement("input");
//       input.type = "hidden";
//       input.name = name;
//       input.value = value ?? "";
//       form.appendChild(input);
//     };

//     // Mandatory PayU fields
//     append("key", p.key);
//     append("txnid", p.txnid);
//     append("amount", p.amount);
//     append("productinfo", p.productinfo);
//     append("firstname", p.firstname);

//     append("email", p.email);
//     append("phone", p.phone);
//     append("hash", p.hash);

//     // For frontend redirect (UI)
//     append("surl", p.surl);
//     append("furl", p.furl);

//     // Optional UDFs
//     append("udf1", p.udf1);

//     document.body.appendChild(form);
//     form.submit();
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
//       <div className="w-full max-w-4xl border-2 border-dashed border-main p-10 bg-[url('https://www.transparenttextures.com/patterns/gplay.png')] bg-repeat rounded-md">
//         <h2 className="md:text-3xl text-2xl text-main font-semibold text-center mb-8">
//           Transaction Details
//         </h2>

//         <form className="space-y-5" onSubmit={handleSubmit}>
//           {[
//             { label: "Amount", name: "amount", type: "number" },
//             { label: "First Name", name: "firstName", type: "text" },
//             { label: "Last Name", name: "lastname", type: "text" },
//             { label: "Email", name: "email", type: "email" },
//             { label: "Telephone", name: "phone", type: "tel" },
//             { label: "Product Info", name: "productInfo", type: "text" },
//             { label: "Company Name", name: "companyName", type: "text" },
//           ].map((field) => (
//             <div
//               key={field.name}
//               className="flex flex-col md:flex-row items-start md:items-center gap-2"
//             >
//               <label className="md:w-40 text-red-600 font-medium">
//                 * {field.label}:
//               </label>
//               <div className="w-full">
//                 <input
//                   type={field.type}
//                   name={field.name}
//                   value={formData[field.name]}
//                   onChange={handleChange}
//                   className="w-full p-2 border rounded"
//                 />
//                 {errors[field.name] && (
//                   <p className="text-red-500 text-sm">{errors[field.name]}</p>
//                 )}
//               </div>
//             </div>
//           ))}

//           <div className="flex justify-center md:justify-end">
//             <button
//               type="submit"
//               disabled={loading}
//               className="bg-sky-500 hover:bg-sky-600 text-white px-6 py-2 rounded font-semibold md:font-bold"
//             >
//               {loading ? "Starting..." : "Pay with PayU"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import BASE_URL from "../../config/config";

export default function PayUCheckout() {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    amount: "",
    firstName: "",
    email: "",
    phone: "",
    productInfo: "",
    companyName: "",
    sourceDomain: window.location.origin,
  });

  const [errors, setErrors] = useState({});

  // AUTO READ URL PARAMS
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const amount = params.get("amount");
    const firstName = params.get("name");
    const email = params.get("email");
    const phone = params.get("phone");
    const companyName = params.get("company");
    // const productInfo = params.get("productInfo");
    const productInfo = params.get("productInfo");

    const sourceDomain = params.get("sourceDomain");

    // IF DATA COMES FROM ivr.deetyasoft.com
    if (amount && firstName && email && phone) {
      const autoData = {
        amount,
        firstName,
        email,
        phone,
        companyName: companyName || "",
        productInfo: productInfo || "Credits Purchase",

        sourceDomain: sourceDomain || window.location.origin,
      };

      // AUTO FILL FORM
      setFormData(autoData);

      // AUTO START PAYMENT
      setTimeout(() => {
        startPaymentWithData(autoData);
      }, 1000);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.amount) newErrors.amount = "Amount is required";

    if (!formData.firstName) newErrors.firstName = "First name is required";

    if (!formData.email) newErrors.email = "Email is required";

    if (!formData.phone) newErrors.phone = "Phone is required";

    if (!formData.productInfo)
      newErrors.productInfo = "Product info is required";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    await startPayment();
  };

  // NORMAL PAYMENT
  const startPayment = async () => {
    try {
      setLoading(true);

      const body = {
        amount: formData.amount,
        productInfo: formData.productInfo,
        firstname: formData.firstName,
        email: formData.email,
        phone: formData.phone,
        companyName: formData.companyName,
        sourceDomain: formData.sourceDomain,
      };

      console.log("Initiating payment with body:", body);

      const res = await fetch(`${BASE_URL}/payments/initiate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (!data?.paymentUrl || !data?.payURequest) {
        alert("Payment initialization failed.");
        return;
      }

      // REDIRECT TO PAYU
      autoSubmitToPayU(data.paymentUrl, data.payURequest);
    } catch (error) {
      console.error("Error starting payment:", error);

      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // AUTO PAYMENT FROM URL PARAMS
  const startPaymentWithData = async (customData) => {
    try {
      setLoading(true);

      const body = {
        amount: customData.amount,
        productInfo: customData.productInfo,
        firstname: customData.firstName,
        email: customData.email,
        phone: customData.phone,
        companyName: customData.companyName,
        sourceDomain: customData.sourceDomain,
      };

      console.log("Auto payment initiated:", body);

      const res = await fetch(`${BASE_URL}/payments/initiate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (!data?.paymentUrl || !data?.payURequest) {
        alert("Payment initialization failed.");
        return;
      }

      // AUTO REDIRECT TO PAYU
      autoSubmitToPayU(data.paymentUrl, data.payURequest);
    } catch (error) {
      console.error("Auto payment error:", error);

      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // PAYU REDIRECT
  const autoSubmitToPayU = (actionUrl, p) => {
    const form = document.createElement("form");

    form.method = "POST";
    form.action = actionUrl;

    const append = (name, value) => {
      const input = document.createElement("input");

      input.type = "hidden";
      input.name = name;
      input.value = value ?? "";

      form.appendChild(input);
    };

    // PAYU FIELDS
    append("key", p.key);
    append("txnid", p.txnid);
    append("amount", p.amount);
    append("productinfo", p.productinfo);
    append("firstname", p.firstname);

    append("email", p.email);
    append("phone", p.phone);
    append("hash", p.hash);

    // SUCCESS / FAILURE URLS
    append("surl", p.surl);
    append("furl", p.furl);

    // // OPTIONAL
    append("udf1", p.udf1);
    append("udf2", p.udf2);

    document.body.appendChild(form);

    form.submit();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
      <div className="w-full max-w-4xl border-2 border-dashed border-main p-10 bg-[url('https://www.transparenttextures.com/patterns/gplay.png')] bg-repeat rounded-md">
        <h2 className="md:text-3xl text-2xl text-main font-semibold text-center mb-8">
          Transaction-Details
        </h2>

        <form className="space-y-5" onSubmit={handleSubmit}>
          {[
            {
              label: "Amount",
              name: "amount",
              type: "number",
            },
            {
              label: "First Name",
              name: "firstName",
              type: "text",
            },
            {
              label: "Email",
              name: "email",
              type: "email",
            },
            {
              label: "Telephone",
              name: "phone",
              type: "tel",
            },
            {
              label: "Product Info",
              name: "productInfo",
              type: "text",
            },
            {
              label: "Company Name",
              name: "companyName",
              type: "text",
            },
          ].map((field) => (
            <div
              key={field.name}
              className="flex flex-col md:flex-row items-start md:items-center gap-2"
            >
              <label className="md:w-40 text-red-600 font-medium">
                * {field.label}:
              </label>

              <div className="w-full">
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                />

                {errors[field.name] && (
                  <p className="text-red-500 text-sm">{errors[field.name]}</p>
                )}
              </div>
            </div>
          ))}

          <div className="flex justify-center md:justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-sky-500 hover:bg-sky-600 text-white px-6 py-2 rounded font-semibold md:font-bold"
            >
              {loading ? "Starting..." : "Pay with PayU"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
